import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { SettlementPaymentStatusOptions } from 'utils/Constant';
import { addSpaceEvery4, money } from 'utils/helpers';

export const PelunasanReportService = (data, date) => {
    const transferSourceOptions = JSON.parse(localStorage.getItem("TransferSource"))
    
    let y = 20

    const doc = new jsPDF('p', 'mm', 'a4');

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Pelunasan Report', 15, y);
    y = y + 8

    // Change to default font size and font wight
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');

    doc.text('Tanggal : ' + moment(date).format("DD MMMM YYYY"), 15, y);
    y = y + 5

    const tableBody = data.map((row) => [
        row.rowNumber,
        row.customerName, 
        `${row.bankCode} \n${addSpaceEvery4(row.cardNumber)}`,
        row.mdr,
        moment(row.dueDate).format('D/M'),
        SettlementPaymentStatusOptions.find(x => x.value === row.paymentStatus).label,
        money(row.billingAmount),
        money(row.customerPayment - row.otherFee),
        money(row.otherFee),
        money(row.transactionAmount),
        row.isTransaction === '0' ? 'Belum Gesek' : 'Sudah Gesek',
    ]);

    autoTable(doc, {
        startY: y,
        head: [[
            'No',
            'Nama Pelanggan', 
            'Kartu',
            'MDR',
            'JT',
            'Status Bayar',
            'Billing',
            'Titipan',
            'Biaya Lain',
            'Gesek Lagi',
            'Status Gesek'
        ]],
        body: tableBody,
        styles: {
            fontSize: 8,
            cellPadding: 1,
            lineWidth: 0.1,
            halign: 'center', // horizontal center
            valign: 'middle', // vertical center
            overflow: 'linebreak'
        },
        headStyles: {
            fillColor: [215, 215, 215],
            textColor: 0,
            halign: 'center',
            valign: 'middle',
            lineWidth: 0.2,
            lineColor: 0
        },
        bodyStyles: {
            fillColor: [255, 255, 255],
            textColor: 0,
            lineWidth: 0.2,
            lineColor: 0
        },
        columnStyles: {
            2: {
                cellWidth: 34, // adjust as needed
            }
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255],
        },
        margin: { top: 15, bottom: 10 },
        pageBreak: 'auto',
        didDrawPage: (data) => {
            const pageCount = doc.internal.getNumberOfPages();
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;

            doc.setFontSize(8);
            doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`, data.settings.margin.left, pageHeight - 5);
        },
    });

    let yPos = doc.lastAutoTable.finalY + 10;
    const pageHeight = doc.internal.pageSize.height;

    if (yPos + 20 > pageHeight) {
        doc.addPage();
        yPos = 20;
    }

    // Open on new tab
    doc.output('dataurlnewwindow');
}